import { getViewAsUser } from "../DevTools/viewAs";
import { useAppSelector } from "../app/hooks";
import { selectHttpCurrentUser } from "../userSelectors";
import { useMsal } from "@azure/msal-react";
import type { AccountInfo } from "@azure/msal-browser";
import { emailIsInternal } from "@multiconsult-group/multiplacer-core";

const getAccountEmail = (account: AccountInfo | null) => {
  if (!account) return "";
  return String((account.idTokenClaims as any)?.preferred_username ?? account.username ?? "");
};

export const useInternalMsalAccount = () => {
  const { instance } = useMsal();
  const currentUser = useAppSelector(selectHttpCurrentUser);
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0] ?? null;
  const email = getAccountEmail(account);
  if (getViewAsUser()) return currentUser?.isExternal === false;
  return email ? emailIsInternal(email) : false;
};
